export default __webpack_public_path__ + "static/media/closeBlue.8f8941c6.svg";